import React, { HTMLAttributes } from 'react';
import svg from './icon.svg';

interface IIcon extends HTMLAttributes<SVGElement> {
    icon: string;
}

const Icon = ({ icon, ...rest }: IIcon) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" {...rest}>
            <use href={`${svg}#${icon}`} xlinkHref={`${svg}#${icon}`} />
        </svg>
    );
};

export default Icon;
